import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import SidePaneViewState from 'owa-calendar-meeting-forms-common-store/lib/store/schema/SidePaneViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateSidePaneType',
    (sidePaneViewState: SidePaneViewState, sidePaneType: SidePaneType) => {
        if (sidePaneViewState) {
            sidePaneViewState.currentSidePaneType = sidePaneType;
        }
    }
);
